function Spellchecker( options ) {

    this.el = options.el;
    this.contentEl = options.contentEl || options.el;
    this.scrollableEl = options.scrollableEl || options.el;
    this.enabled = true;

    this.getCorrections = options.getCorrections || function() {};
    this.abortCorrectionsCallback = options.abortCorrections || function() {};
    this.dictionaryCache = options.dictionaryCache || [];
    this.correctionCache = options.correctionCache || {};

    this.wordFilters = [];
    ( options.wordFilters || [] )
        .forEach( function( pattern ) {
            this.wordFilters.push( new RegExp( pattern ) );
        }.bind( this ) );

    options.delay = options.delay || 0.5;
    this.debouncedCheck = this.debounce( function() {

        this.check();

    }, options.delay * 1000 );

    this.removeElementsIfScrolledHorizontally = this.removeElementsIfScrolledHorizontally.bind( this );

}

Spellchecker.prototype.check = function() {

    if ( !this.enabled ) {
        return;
    }

    this.abortCorrections();

    const words = this.findWords();
    if ( !words ) {
        return;
    }

    const dictionaryCache = this.dictionaryCache;
    const correctionCache = this.correctionCache;
    const newWords = [];
    let cachedCorrections = null;

    for ( let i = 0; i < words.words.length; i++ ) {
        const word = words.words[ i ];
        if ( correctionCache[ word ] ) {
            if ( !cachedCorrections ) {
                cachedCorrections = {};
            }
            cachedCorrections[ word ] = correctionCache[ word ];
        }
        else if ( dictionaryCache.indexOf( word ) == -1 ) {
            newWords.push( word );
        }
    }

    if ( newWords.length ) {

        this.willDisplayCorrections = true;

        this.getCorrections( {
            words : newWords.join( ',' ),
            success : function( serverCorrections ) {

                for ( let i = 0; i < newWords.length; i++ ) {
                    if ( !serverCorrections[ newWords[ i ] ] ) {
                        dictionaryCache.push( newWords[ i ] );
                    }
                }
                if ( serverCorrections.length !== 0 ) {
                    this.assign( correctionCache, serverCorrections );
                }

                if ( !this.willDisplayCorrections ) {
                    return;
                }
                this.willDisplayCorrections = false;

                this.showCorrections(
                    this.assign( {}, cachedCorrections || {}, serverCorrections || {} ),
                    words.wordsSpanningNodes
                );

            }.bind( this )
        } );

    }
    else if ( cachedCorrections ) {

        this.showCorrections( cachedCorrections, words.wordsSpanningNodes );

    }

};

Spellchecker.prototype.willSkipWord = function( word ) {

    word = word.replace( /['\u2018\u2019]/g, '' );
    if ( word.length < 2 ) {
        return true;
    }
    for ( let i = 0; i < this.wordFilters.length; i++ ) {
        const re = this.wordFilters[ i ];
        if ( re.test( word ) ) {
            return true;
        }
    }
    return false;

};

Spellchecker.prototype.findWords = function() {

    const editorEl = this.contentEl;
    const uniqueWords = [];
    let node;
    const nodeIterator = this.createTextNodeIterator( editorEl );
    const nodes = [];
    const endsWithSeparator = /[^\w'\u2018\u2019]$/;
    const wordSplitter = /[^\w'\u2018\u2019]/;
    const wordsSpanningNodes = {};

    const range = document.createRange();
    const scrollable = this.scrollableEl;

    // eslint-disable-next-line no-cond-assign
    while ( node = nodeIterator.nextNode() ) {

        range.selectNodeContents( node );
        const nodeRect = range.getBoundingClientRect();

        if ( !nodeRect ) {
            continue;
        }

        if ( scrollable ) {
            const scrollableRect = scrollable.getClientRects()[ 0 ];

            if ( !scrollableRect ) {
                continue;
            }

            const nodeTop = nodeRect.top - scrollableRect.top;
            const nodeBottom = nodeRect.bottom - scrollableRect.top;

            if ( nodeTop < 0 && nodeBottom > 0 || nodeTop > 0 && nodeTop <= scrollable.clientHeight ) {
                nodes.push( {
                    node : node,
                    rect : nodeRect
                } );
            }

        } else {
            nodes.push( {
                node : node,
                rect : nodeRect
            } );
        }

    }

    let adjacentNodes = [];
    nodes.forEach( function( node ) {
        if ( adjacentNodes.includes( node ) ) {
            return;
        }

        if ( node.node.nodeType !== Node.TEXT_NODE ) {
            return;
        }

        if ( [ 'A' ].includes( node.node.parentNode.tagName ) ) {
            return;
        }

        let text = node.node.nodeValue;
        const urlPattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-zA-Z]{2,6}\b([-a-zA-Z0-9@:%_+.~#()?&//=]*)/;
        const emailPattern = /([^.@\s]+)(\.[^.@\s]+)*@([^.@\s]+\.)+([^.@\s]+)/;
        for ( const pattern of [ urlPattern, emailPattern ] ) {
            if ( pattern.test( text ) ) {
                text = text.replace( pattern, '' );
            }
        }

        let words = text.split( wordSplitter );
        let word;

        if ( !endsWithSeparator.test( text ) ) {
            let adjacentNode = node;
            const nodesForWord = [ node ];

            word = words[ words.length - 1 ];
            node.startOffset = text.length - words[ words.length - 1 ].length;

            // eslint-disable-next-line no-cond-assign
            while ( adjacentNode = this.searchForAdjacentNodes( adjacentNode, nodes ) ) {
                if ( adjacentNode.node.nodeType === Node.TEXT_NODE ) {
                    text += adjacentNode.node.nodeValue;
                    word += adjacentNode.node.nodeValue.split( wordSplitter )[ 0 ];
                    nodesForWord.push( adjacentNode );
                }
                if ( nodesForWord.length >= 5 ) {
                    break;
                }
            }

            if ( nodesForWord.length > 1 ) {

                const lastNode = nodesForWord[ nodesForWord.length - 1 ];
                lastNode.endOffset = lastNode.node.nodeValue.split( wordSplitter )[ 0 ].length;

                words = text.split( wordSplitter );
                adjacentNodes = adjacentNodes.concat( nodesForWord );
                wordsSpanningNodes[ word ] = wordsSpanningNodes[ word ] || [];
                wordsSpanningNodes[ word ].push( nodesForWord );

            }
        }

        for ( let i = 0; i < words.length; i++ ) {
            word = words[ i ];
            if ( this.willSkipWord( word ) ) {
                continue;
            }
            if ( uniqueWords.indexOf( word ) == -1 ) {
                uniqueWords.push( word );
            }
        }

    }.bind( this ) );

    if ( !uniqueWords.length && this.isEmpty( wordsSpanningNodes ) ) {
        return null;
    }

    return {
        words : uniqueWords,
        wordsSpanningNodes : wordsSpanningNodes
    };

};

Spellchecker.prototype.searchForAdjacentNodes = function( node, otherNodes ) {

    const startsWithSeparator = /^[^\w'’]/;
    const pixelLimit = 3;

    for ( let otherNodeIndex = 0; otherNodeIndex < otherNodes.length; otherNodeIndex++ ) {
        const otherNode = otherNodes[ otherNodeIndex ];
        if ( otherNode == node ) {
            continue;
        }
        const otherRect = otherNode.rect;
        if (
            Math.abs( node.rect.top - otherRect.top ) < pixelLimit &&
            Math.abs( node.rect.bottom - otherRect.bottom ) < pixelLimit &&
            Math.abs( node.rect.right - otherRect.left ) < pixelLimit &&
            !startsWithSeparator.test( otherNode.node.nodeValue )
        ) {
            return otherNode;
        }
    }

};

Spellchecker.prototype.createTextNodeIterator = function( element ) {

    return document.createNodeIterator( element, NodeFilter.SHOW_TEXT, function( node ) {
        if ( node.textContent.trim().length ) {
            return NodeFilter.FILTER_ACCEPT;
        }
        return NodeFilter.FILTER_REJECT;
    }, false );

};

Spellchecker.prototype.createTypoElement = function( editorEl, offsetClientRect, correction, boundingRect ) {

    correction.editorRange = {
        startContainer : correction.range.startContainer,
        startOffset : correction.range.startOffset,
        endContainer : correction.range.endContainer,
        endOffset : correction.range.endOffset
    };

    const invisibleEL = document.createElement( 'span' );
    try {
        correction.range.surroundContents( invisibleEL );
    }
    // eslint-disable-next-line no-empty
    catch ( e ) {
    }

    let clientRect;
    if ( boundingRect ) {
        clientRect = invisibleEL.getBoundingClientRect();
    }
    else {
        clientRect = correction.range.getClientRects()[ 0 ];
    }

    const visibleEl = correction.el = document.createElement( 'span' );
    const offsetTop = offsetClientRect.top - editorEl.offsetParent.scrollTop;

    visibleEl.className = 'typo';
    visibleEl.style.left = clientRect.left - offsetClientRect.left + 'px';
    visibleEl.style.top = clientRect.top - offsetTop + 'px';
    visibleEl.style.width = clientRect.width + 'px';
    visibleEl.style.height = clientRect.height + 'px';

    editorEl.parentNode.appendChild( visibleEl );

};

Spellchecker.prototype.showCorrections = function( corrections, wordsSpanningNodes ) {

    if ( this.isEmpty( corrections ) ) {
        return;
    }

    this.removeElements();

    const editorEl = this.el;
    const offsetClientRect = editorEl.offsetParent.getClientRects()[ 0 ];
    const cloneEl = this.createCloneEl( editorEl );
    const nodeIterator = this.createTextNodeIterator( cloneEl );
    const showingCorrections = [];
    let textNode;
    let range;
    let typo;

    for ( typo in wordsSpanningNodes ) {
        // eslint-disable-next-line no-prototype-builtins
        if ( !wordsSpanningNodes.hasOwnProperty( typo ) ) {
            continue;
        }
        if ( !corrections[ typo ] ) {
            continue;
        }
        const nodes = wordsSpanningNodes[ typo ];
        for ( let nodeIndex = 0; nodeIndex < nodes.length; nodeIndex++ ) {
            const node = nodes[ nodeIndex ];
            range = document.createRange();

            range.setStart(
                this.nodeFromPath( cloneEl,
                    this.pathFromNode( editorEl, node[ 0 ].node ) ),
                node[ 0 ].startOffset
            );

            range.setEnd(
                this.nodeFromPath( cloneEl,
                    this.pathFromNode( editorEl, node[ node.length - 1 ].node ) ),
                node[ node.length - 1 ].endOffset
            );

            const correction = {
                typo : typo,
                range : range,
                spanning : true
            };

            this.createTypoElement( editorEl, offsetClientRect, correction, true );

            showingCorrections.push( correction );
        }
    }

    const typoLocators = {};
    for ( typo in corrections ) {
        // eslint-disable-next-line no-prototype-builtins
        if ( !corrections.hasOwnProperty( typo ) ) {
            continue;
        }
        typoLocators[ typo ] = {
            re : new RegExp( '(\\b' + typo + '\\b)(?![\'\\u2018\\u2019])', 'g' ),
            suggestions : corrections[ typo ]
        };
    }

    const simpleCorrections = [];
    // eslint-disable-next-line no-cond-assign
    while ( textNode = nodeIterator.nextNode() ) {

        if ( [ 'A' ].indexOf( textNode.parentNode.tagName ) != -1 ) {
            continue;
        }
        for ( typo in typoLocators ) {
            // eslint-disable-next-line no-prototype-builtins
            if ( !typoLocators.hasOwnProperty( typo ) ) {
                continue;
            }
            const typoLocator = typoLocators[ typo ];
            let match;
            // eslint-disable-next-line no-cond-assign
            while ( match = typoLocator.re.exec( textNode.nodeValue ) ) {

                range = document.createRange();
                range.setStart( textNode, match.index );
                range.setEnd( textNode, match.index + typo.length );

                simpleCorrections.push( {
                    typo : typo,
                    range : range,
                    offset : match.index
                } );

            }
        }

    }
    for ( let correctionIndex = 0; correctionIndex < simpleCorrections.length; correctionIndex++ ) {
        this.createTypoElement(
            editorEl, offsetClientRect, simpleCorrections[ correctionIndex ]
        );
    }
    this.showingCorrections = showingCorrections.concat( simpleCorrections );

    this.previousCorrections = corrections;

    this.addResizeListener();

};

Spellchecker.prototype.createCloneEl = function( editorEl ) {

    const cloneEl = this.cloneEl = editorEl.cloneNode( true );
    const marginOffset = window.getComputedStyle( editorEl ).marginLeft.replace( /\D+/, '' );

    cloneEl.classList.add( 'spellcheckClone' );
    cloneEl.style.setProperty( 'grid-area', '' );
    cloneEl.style.setProperty( 'flex', '' );
    cloneEl.style.visibility = 'hidden';
    cloneEl.style.position = 'absolute';
    cloneEl.style.inset = 0;

    const imageIterator = document.createNodeIterator( cloneEl, NodeFilter.SHOW_ELEMENT, function( node ) {
        if ( node.tagName == 'IMG' ) {
            return NodeFilter.FILTER_ACCEPT;
        }
        return NodeFilter.FILTER_REJECT;
    }, false );
    const createEditorImageIterator = function( src ) {
        return document.createNodeIterator( editorEl, NodeFilter.SHOW_ELEMENT, function( node ) {
            if ( node.tagName == 'IMG' && node.src == src ) {
                return NodeFilter.FILTER_ACCEPT;
            }
            return NodeFilter.FILTER_REJECT;
        }, false );
    };
    const transparentGifUrl = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    let placeholderImage;
    const debouncedReposition = this.debounce(
        this.repositionElements.bind( this ), 20
    );
    const createEditorImageLoadHandler = function( editorImage, placeholderImage ) {
        return function( placeholderImage ) {
            placeholderImage.style.width = this.offsetWidth + 'px';
            placeholderImage.style.height = this.offsetHeight + 'px';
            debouncedReposition();
        }.bind( editorImage, placeholderImage );
    };

    // eslint-disable-next-line no-cond-assign
    while ( placeholderImage = imageIterator.nextNode() ) {

        const editorImageIterator = createEditorImageIterator( placeholderImage.src );
        placeholderImage.src = transparentGifUrl;

        const editorImage = editorImageIterator.nextNode();
        if ( !editorImage ) {
            continue;
        }

        placeholderImage.style.width = editorImage.offsetWidth + 'px';
        placeholderImage.style.height = editorImage.offsetHeight + 'px';

        if ( !editorImage.naturalWidth ) {
            editorImage.addEventListener( 'load',
                createEditorImageLoadHandler( editorImage, placeholderImage ) );
            editorImage.addEventListener( 'error',
                createEditorImageLoadHandler( editorImage, placeholderImage ) );
        }

    }

    editorEl.parentNode.insertBefore( cloneEl, editorEl.nextSibling );
    cloneEl.scrollLeft = editorEl.scrollLeft;

    return cloneEl;

};

Spellchecker.prototype.repositionElements = function() {

    const editorEl = this.el;
    const cloneEl = this.cloneEl;

    if ( !editorEl.offsetParent || !cloneEl || !cloneEl.parentNode ) {
        return;
    }

    cloneEl.style.inset = 0;
    cloneEl.scrollLeft = editorEl.scrollLeft;

    const corrections = this.showingCorrections;
    if ( !corrections ) {
        return;
    }
    if ( !editorEl.offsetParent ) {
        return;
    }

    const offsetClientRect = editorEl.offsetParent.getClientRects()[ 0 ];
    const offsetTop = offsetClientRect.top - editorEl.offsetParent.scrollTop;

    for ( let i = 0; i < corrections.length; i++ ) {
        const correction = corrections[ i ];
        const clientRect = correction.spanning ? correction.el.getBoundingClientRect() : correction.range.getClientRects()[ 0 ];
        const el = correction.el;

        el.style.left = clientRect.left - offsetClientRect.left + 'px';
        el.style.top = clientRect.top - offsetTop + 'px';
        el.style.width = clientRect.width + 'px';
        el.style.height = clientRect.height + 'px';
    }

};

Spellchecker.prototype.removeElements = function() {

    if ( this.cloneEl ) {
        if ( this.cloneEl.parentNode ) {
            this.cloneEl.parentNode.removeChild( this.cloneEl );
        }
        delete this.cloneEl;
    }

    const corrections = this.showingCorrections;
    if ( corrections ) {
        for ( let i = 0; i < corrections.length; i++ ) {
            const correction = corrections[ i ];
            if ( correction.el.parentNode ) {
                correction.el.parentNode.removeChild( correction.el );
            }
        }
        delete this.showingCorrections;
    }

};

Spellchecker.prototype.findCorrection = function() {

    const contextMenuPosition = this.contextMenuPosition;
    if ( !contextMenuPosition ) {
        return;
    }

    const corrections = this.showingCorrections;
    if ( !corrections ) {
        return;
    }
    for ( let i = 0; i < corrections.length; i++ ) {
        const correction = corrections[ i ];
        const clientRect = correction.spanning ? correction.el.getBoundingClientRect() : correction.range.getClientRects()[ 0 ];
        if (
            clientRect &&
            contextMenuPosition[ 0 ] >= clientRect.left &&
            contextMenuPosition[ 0 ] <= clientRect.right &&
            contextMenuPosition[ 1 ] >= clientRect.top &&
            contextMenuPosition[ 1 ] <= clientRect.bottom
        ) {
            return this.assign( {
                suggestions : this.previousCorrections[ correction.typo ]
            }, correction );
        }
    }

};

Spellchecker.prototype.addResizeListener = function() {

    if ( this.resizeListenerReady ) {
        return;
    }

    const el = this.el.parentNode;
    let previousWidth = el.offsetWidth;
    let previousTop = el.offsetTop;
    this.resizeListenerInterval = window.setInterval( function() {

        if ( !this.enabled ) {
            return;
        }

        const currentWidth = el.offsetWidth;
        const currentTop = el.offsetTop;

        if ( currentWidth != previousWidth || currentTop != previousTop ) {
            this.repositionElements();
            previousWidth = currentWidth;
            previousTop = currentTop;
        }

    }.bind( this ), 100 );

    this.resizeListenerReady = true;

};

Spellchecker.prototype.removeResizeListener = function() {

    if ( this.resizeListenerInterval ) {
        window.clearInterval( this.resizeListenerInterval );
        delete this.resizeListenerInterval;
    }

    delete this.resizeListenerReady;

};

Spellchecker.prototype.addScrollListener = function() {

    if ( this.addedScrollListener ) {
        return;
    }
    this.scrollableEl.addEventListener( 'scroll', this.removeElementsIfScrolledHorizontally, {
        passive : true
    } );

    this.scrollableEl.addEventListener( 'scroll', this.debouncedCheck, {
        passive : true
    } );

    this.addedScrollListener = true;

};

Spellchecker.prototype.removeScrollListener = function() {

    if ( !this.addedScrollListener ) {
        return;
    }

    this.scrollableEl.removeEventListener( 'scroll', this.debouncedCheck );

    this.scrollableEl.removeEventListener( 'scroll', this.removeElementsIfScrolledHorizontally );

    this.addedScrollListener = false;

};

Spellchecker.prototype.removeElementsIfScrolledHorizontally = function() {

    const scrollLeft = this.scrollableEl.scrollLeft;
    if ( this.previousScrollLeft !== undefined && this.previousScrollLeft != scrollLeft ) {
        this.removeElements();
    }
    this.previousScrollLeft = scrollLeft;

};

Spellchecker.prototype.updateScrollListener = function( scrollableEl ) {

    if ( !scrollableEl ) {
        return;
    }

    this.removeScrollListener();
    this.scrollableEl = scrollableEl;
    this.addScrollListener();

};

Spellchecker.prototype.contextMenuHandler = function( editor, event ) {

    this.contextMenuPosition = [
        event.data.$.clientX,
        event.data.$.clientY
    ];

};

Spellchecker.prototype.changeHandler = function() {

    if ( !this.enabled ) {
        return;
    }

    this.removeElements();
    if ( this.correcting ) {

        this.showCorrections( this.previousCorrections );
        delete this.correcting;

    }
    else {

        this.abortCorrections();
        this.debouncedCheck();

    }

};

Spellchecker.prototype.addToDictionary = function( word ) {

    delete this.correctionCache[ word ];
    this.dictionaryCache.push( word );

};

Spellchecker.prototype.debounce = function( fn, wait ) {

    let timeout;
    const context = this;
    const args = arguments;
    const debounced = function() {

        if ( timeout ) {
            window.clearTimeout( timeout );
        }
        timeout = window.setTimeout( function() {
            fn.apply( context, args );
        }, wait );

    };

    return debounced;

};

Spellchecker.prototype.pathFromNode = function( container, startNode ) {

    let node = startNode;
    const path = [];
    while ( node != container && node.parentNode ) {
        path.unshift(
            Array.prototype.indexOf.call(
                node.parentNode.childNodes, node
            )
        );
        node = node.parentNode;
    }
    return path;

};

Spellchecker.prototype.nodeFromPath = function( container, path ) {

    let node = container;
    for ( let i = 0; i < path.length; i++ ) {
        node = node.childNodes[ path[ i ] ];
    }
    return node;

};

Spellchecker.prototype.textNodeAtPoint = function( el, xy ) {

    const nodeIterator = this.createTextNodeIterator( el );
    let node;
    const range = document.createRange();
    // eslint-disable-next-line no-cond-assign
    while ( node = nodeIterator.nextNode() ) {

        range.selectNode( node );

        const rects = range.getClientRects();
        for ( let i = 0; i < rects.length; i++ ) {
            const rect = rects[ i ];
            if ( xy[ 0 ] >= rect.left && xy[ 0 ] <= rect.right && xy[ 1 ] >= rect.top && xy[ 1 ] <= rect.bottom ) {
                return node;
            }
        }

    }

};

Spellchecker.prototype.getTypoRange = function( correction ) {

    const selection = window.getSelection();
    let range;
    if ( selection.rangeCount ) {
        range = selection.getRangeAt( 0 );
        if ( range.endOffset - range.startOffset !== 0 ) {
            return range;
        }
    }
    else {
        range = document.createRange();
        selection.addRange( range );
    }

    if ( correction.spanning ) {

        range.setStart(
            this.nodeFromPath( this.contentEl,
                this.pathFromNode( this.cloneEl, correction.editorRange.startContainer ) ),
            correction.editorRange.startOffset
        );
        range.setEnd(
            this.nodeFromPath( this.contentEl,
                this.pathFromNode( this.cloneEl, correction.editorRange.endContainer ) ),
            correction.editorRange.endOffset
        );

    }
    else {

        const xy = this.contextMenuPosition;
        let el = document.elementFromPoint( xy[ 0 ], xy[ 1 ] );
        if ( el ) {
            if ( el.nodeType != Node.TEXT_NODE ) {
                el = this.textNodeAtPoint( el, xy );
            }
            if ( el ) {
                range.setStart( el, correction.offset );
                range.setEnd( el, correction.offset + correction.typo.length );
            }
        }

    }

    return range;

};

Spellchecker.prototype.assign = function( target ) {

    for ( let i = 1; i < arguments.length; i++ ) {
        const source = arguments[ i ];
        for ( const property in source ) {
            // eslint-disable-next-line no-prototype-builtins
            if ( source.hasOwnProperty( property ) ) {
                target[ property ] = source[ property ];
            }
        }
    }
    return target;

};

Spellchecker.prototype.isEmpty = function( object ) {

    for ( const property in object ) {
        // eslint-disable-next-line no-prototype-builtins
        if ( object.hasOwnProperty( property ) ) {
            return false;
        }
    }
    return true;

};

Spellchecker.prototype.abortCorrections = function() {

    this.willDisplayCorrections = false;

    this.abortCorrectionsCallback();

};

Spellchecker.prototype.remove = function() {

    this.abortCorrections();
    this.removeResizeListener();
    this.removeScrollListener();
    this.removeElements();

};
